module.exports = __webpack_public_path__ + "media/soundtrack.a1491d3d.mp3";